import { AuthContextProvider } from "./auth";
import { BreadcrumbContextProvider } from "./breadcrumb";

export const GlobalContext = ({ children }) => {
    return (
        <AuthContextProvider>
            <BreadcrumbContextProvider>
                {children}
            </BreadcrumbContextProvider>
        </AuthContextProvider>
    );
}